export const rightToLeftLanguages = ['ar_SA', 'he_HE'];
